<template>
    <div v-cloak class="simple-form">
        <el-form :model="realCom" :rules="roles" ref="realCom" class="demo-ruleForm">
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">名称</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="name" :rules="{validator : validNull, trigger: 'blur'}">
                        <el-input v-model="realCom.name" class="width-2x" type="text" auto-complete="off"></el-input>
                        <span class="swb-btn swb-btn-link" v-if="isAdd" @click="setRealCom">选择实体公司</span>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">代码</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="code" :rules="{validator : validNull, trigger: 'blur'}">
                        <el-input v-model="realCom.code" :disabled="realCom.id != null" class="width-2x" type="text" auto-complete="off"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>是否三证合一</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="integratedFlag">
                        <el-radio-group v-model="realCom.integratedFlag">
                            <el-radio :label="true">是</el-radio>
                            <el-radio :label="false">否</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>执照注册号</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="registNo">
                        <el-input v-model="realCom.registNo" class="width-2x" type="text" auto-complete="off"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>统一社会信用代码</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="socialCreditCode">
                        <el-input v-model="realCom.socialCreditCode" class="width-2x" type="text" auto-complete="off"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>企业类型</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="orgForm">
                        <el-input v-model="realCom.orgForm" class="width-2x" type="text" auto-complete="off"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>组织机构代码</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="orgCode">
                        <el-input v-model="realCom.orgCode" class="width-2x" type="text" auto-complete="off"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>法人代表</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="legalPerson">
                        <el-input v-model="realCom.legalPerson" class="width-2x" type="text" auto-complete="off"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>注册资金</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="registCapital" :rules="{validator : validCapital, trigger: 'blur'}">
                        <el-input class="width-2x" v-model.number="realCom.registCapital" type="number" min="0" placeholder="请输入数字"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>成立日期</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="foundDate">
                        <el-date-picker class="width-2x" v-model="realCom.foundDate" type="date" placeholder="选择日期"></el-date-picker>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>营业开始日期</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="bizTermStartDate">
                        <el-date-picker class="width-2x" v-model="realCom.bizTermStartDate" type="date" placeholder="选择日期"></el-date-picker>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>营业截止日期</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="bizTermEndDate">
                        <el-date-picker class="width-2x" v-model="realCom.bizTermEndDate" type="date" placeholder="选择日期"></el-date-picker>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>税务登记号</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="taxRegistNo">
                        <el-input v-model="realCom.taxRegistNo" class="width-2x" type="text" auto-complete="off"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>纳税类型编码</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="taxPayTypeCode">
                        <el-input v-model="realCom.taxPayTypeCode" class="width-2x" type="text" auto-complete="off" @change="taxPayTypeCodechange"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">纳税类型</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="taxPayType" :rules="{validator : validNull, trigger: 'change'}">
                        <el-input class="width-2x bottom-line" disabled type="text" v-model="realCom.taxPayTypeName"></el-input>
                        <div class="form-tips icon iconfont icon-chazhaobiaodanliebiao relation-icon" title="选择" @click="selectCustTaxPayType()"></div>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>经营范围</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="bizScope">
                        <el-input v-model="realCom.bizScope" class="width-2x" type="text" auto-complete="off"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>员工人数</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="staffCount">
                        <el-input class="width-2x" v-model.number="realCom.staffCount" type="number" min="0" placeholder="请输入数字"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>是否抵扣税</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="taxFree">
                        <el-select placeholder="请选择" v-model="realCom.taxFree">
                            <el-option v-for="taxOsJudgeWay in taxOsJudgeWayList" :label="taxOsJudgeWay.text" :value="taxOsJudgeWay.value"></el-option>
                        </el-select>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">联系人姓名</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="contactName" :rules="{validator : validNull, trigger: 'blur'}">
                        <el-input v-model="realCom.contactName" class="width-2x" type="text" auto-complete="off"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">联系电话</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="contactTel" :rules="{validator : validNull, trigger: 'blur'}">
                        <el-input v-model="realCom.contactTel" class="width-2x" type="text" auto-complete="off"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">联系邮箱</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="contactEmail" :rules="{validator : validNull, trigger: 'blur'}">
                        <el-input v-model="realCom.contactEmail" class="width-2x" type="text" auto-complete="off"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">公司介绍</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="briefIntro" :rules="{validator : validNull, trigger: 'blur'}">
                        <el-input v-model="realCom.briefIntro" class="width-2x" type="textarea"></el-input>
                    </el-form-item>
                </div>
            </div>
        </el-form>
    </div>
</template>

<script>
    //
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import { selectCustTaxPayTypeDlg } from '../comn/dialog'
    import { selectRealComDlg } from '../comn/dialog'

    import merchtComnApi from '../../api/merchtComn'

    export default {
        name: 'swb-merchant-real-com-save',
        desc: '实体公司',
        props: ['item', 'isAdd'],
        data: function () {
            return {
                realCom: {
                    name: null,
                    code: null,
                    integratedFlag: true,
                    registNo: null,
                    socialCreditCode: null,
                    orgForm: null,
                    orgCode: null,
                    legalPerson: null,
                    registCapital: null,
                    foundDate: null,
                    bizTermStartDate: null,
                    bizTermEndDate: null,
                    taxRegistNo: null,
                    bizScope: null,
                    staffCount: null,
                    contactName: null,
                    contactTel: null,
                    contactEmail: null,
                    briefIntro: null,
                    taxFree: 0
                },
                taxPayTypeMap: getEnumMap("taxPayType", "value2text"),
                taxOsJudgeWayList: getEnumList("taxOsJudgeWay"),
                dbIds: []
            }
        },
        created: function () {
            let item = this.item;
            if(!Utils.isNoB(item) && item.id != null) {
                item.taxPayTypeName = this.taxPayTypeMap[item.taxPayType];
                this.realCom = Utils.merge({}, item);
            }
            this.getDataList();
        },
        methods: {
            validCapital: function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback();
                } else {
                    if(!Utils.isMoneyStr(value, true)) {
                        callback(new Error('请填写正确的金额'));
                    } else {
                        callback();
                    }
                }
            },
            validNull: function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('不可为空'));
                } else {
                    callback();
                }
            },
            // 纳税类型编码变化事件
            taxPayTypeCodechange: function () {
                let self = this;
                let realCom = self.realCom || {};
                let params = {
                    code: realCom.taxPayTypeCode
                };
                //
                let theLoading = MsgBox.loading();
                merchtComnApi.getCustTaxPayTypeByCode(params, function (result) {
                    theLoading.close();
                    if(result.type == 'info') {
                        let custTaxPayType = result.data;
                        if(!Utils.isNoB(custTaxPayType) && custTaxPayType.id > 0) {
                            realCom.taxPayType = custTaxPayType.stdValue;
                            realCom.taxPayTypeName = custTaxPayType.stdName;
                            self.realCom = Utils.merge({}, realCom);
                        }
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 选择自定义纳税类型
            selectCustTaxPayType: function () {
                let self = this;
                let realCom = self.realCom || {};
                let selectStdValues = [];
                if(!Utils.isNoB(realCom.taxPayType) && !selectStdValues.contains(realCom.taxPayType)) {
                    selectStdValues.push(realCom.taxPayType);
                }
                let params = {
                    checkBox: false,
                    selectStdValues: selectStdValues
                };
                selectCustTaxPayTypeDlg(params, function (custTaxPayType, theDlg) {
                    theDlg.close();
                    //
                    realCom.taxPayType = custTaxPayType.stdValue;
                    realCom.taxPayTypeCode = custTaxPayType.code;
                    realCom.taxPayTypeName = custTaxPayType.stdName;
                    self.realCom = Utils.merge({}, realCom);
                });
            },
            getDataList(){
                let self = this;
                merchtComnApi.getMerchantRealComList({
                    pagination: {
                        pageSize: 99999999,
                        pageNumber: 1
                    }
                }, function (result) {
                    if(result.type == 'info') {
                        let srcDataList = result.data.rows;
                        self.dbIds = srcDataList.pluck('id');
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            //
            getDlgResult: function () {
                // 提供回调函数，返回结果
                let self = this;
                let result = {};
                this.$refs['realCom'].validate(function (valid) {
                    if(valid) {
                        result.type = "info";
                        result.data = self.realCom;
                    } else {
                        result.type = "warn";
                        result.message = "校验失败";
                    }
                });
                return result;
            },
            setRealCom() {
                let self = this;
                selectRealComDlg({disabledIds: self.dbIds}, function (realCom, theDlg) {
                    theDlg.close();
                    realCom.taxPayTypeName = self.taxPayTypeMap[realCom.taxPayType];
                    self.realCom = Utils.merge({}, realCom);
                });
            },
        }
    }
</script>





// WEBPACK FOOTER //
// src/compo/realCom/MerchantRealComSave.vue